/**
 * Shared configuration for voice token retry and circuit breaker behavior
 */
export const TOKEN_FETCH_CONFIG = {
  maxAttempts: 3,
  maxBackoffMs: 16000, // 16 seconds max backoff
  backoffFactor: 2,
  baseDelayMs: 1000,
};

export const VOICE_ERROR_MESSAGES = {
  CIRCUIT_OPEN: "Voice service is temporarily unavailable. Please try again in a few minutes.",
  TOKEN_FETCH_FAILED: "Failed to get voice token. Please try again.",
  CONNECTION_FAILED: "Unable to connect to voice service. Please check your connection and try again.",
};